import React, { useState, createContext, useContext } from 'react';
import { translations } from '../data/translations';
type Language = 'es' | 'en';
interface LanguageContextType {
  language: Language;
  toggleLanguage: () => void;
  t: (section: keyof (typeof translations)['es'], key: string) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('es');
  const toggleLanguage = () => {
    setLanguage(prev => prev === 'es' ? 'en' : 'es');
  };
  const t = (section: keyof (typeof translations)['es'], key: string): string => {
    // @ts-ignore - dynamic key access
    return translations[language][section][key] || key;
  };
  return <LanguageContext.Provider value={{
    language,
    toggleLanguage,
    t
  }} data-id="element-417">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}